import React, { useEffect, useRef } from "react";
import { useTheme } from "../theme/ThemeProvider";

// Desktop-only, pointer-fine, and never when the user prefers reduced motion.
export const ambientCapable = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(min-width: 1024px)").matches &&
  window.matchMedia("(pointer: fine)").matches &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Subtle animated aurora behind the page. Three.js is loaded lazily so phones
 * and users with effects off never download it. Re-mounts on skin/theme change
 * so the blob colours follow the active tokens.
 */
const AmbientBackground = () => {
  const { ambientEffects, skin, resolvedTheme } = useTheme();
  const ref = useRef(null);

  useEffect(() => {
    if (!ambientEffects || !ambientCapable()) return undefined;
    let disposed = false;
    let cleanup = null;
    import("../theme/ambientScene")
      .then((m) => {
        if (disposed || !ref.current) return;
        cleanup = m.mountAmbient(ref.current);
      })
      .catch(() => {
        /* WebGL unavailable — silently skip */
      });
    return () => {
      disposed = true;
      if (cleanup) cleanup();
    };
  }, [ambientEffects, skin, resolvedTheme]);

  if (!ambientEffects) return null;
  return <div ref={ref} aria-hidden="true" className="xz-ambient" />;
};

export default AmbientBackground;
